import React, { useState } from 'react';
import { Card } from 'antd';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import './TaskItem.css';

// Dual layout: Card for desktop, search-item for mobile (matching RelatedCampaigns pattern)

function TaskItem({ item, isMobile = false }) {
  const { t } = useTranslation();
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = (e) => {
    e.target.style.display = 'none';
  };

  // Mobile layout - horizontal search item (matching RelatedCampaigns mobile pattern)
  if (isMobile) {
    return (
      <Link to={`/task?id=${item.id}`}>
        <div className="search-task-item">
          <div className="search-task-image">
            {item.image_url && (
              <img
                alt={item.name}
                src={item.image_url}
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{ opacity: imageLoaded ? 1 : 0.7 }}
              />
            )}
          </div>
          <div className="search-task-content">
            <div className="search-task-title">
              {item.name}
            </div>
            <div className="search-task-meta">
              {item.skill?.name} | {item.miles} {t('common.mile', { count: item.miles })}
            </div>
          </div>
        </div>
      </Link>
    );
  }

  // Desktop layout - vertical card (matching RelatedCampaigns desktop pattern)
  return (
    <Link to={`/task?id=${item.id}`}>
      <Card
        hoverable
        cover={
          item.image_url && (
            <div className="task-card-image">
              <img
                alt={item.name}
                src={item.image_url}
                onLoad={handleImageLoad}
                onError={handleImageError}
                style={{ opacity: imageLoaded ? 1 : 0.7 }}
              />
            </div>
          )
        }
        className="task-card"
      >
        <Card.Meta
          title={
            <div className="task-card-title">
              {item.name}
            </div>
          }
          description={
            <div className="task-card-meta">
              {item.skill?.name} • {item.miles} {t('common.mile', { count: item.miles })}
            </div>
          }
        />
      </Card>
    </Link>
  );
}

export default TaskItem;
